import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
} from "prop-types";
import { Link } from "react-router-dom";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import New from "./New";
import classes from "./titleLabel.scss";

const ProductCardTitleLabel = ({ name, ids, to, onClick, isDisabled }) => {
  return (
    <div className={`${classes.root} ${isDisabled ? classes.disabled : ""}`}>
      {isArrayHasItems(ids) && <New code="new" ids={ids} />}
      <h2 className={classes.title} data-t2={name} data-t1="title_label">
        <Link
          to={to}
          data-t1="title_label_link"
          title={name}
          data-t2={to}
          onClick={onClick}
        >
          {name}
        </Link>
      </h2>
    </div>
  );
};

ProductCardTitleLabel.propTypes = {
  name: string.isRequired,
  to: shape({}).isRequired,
  ids: arrayOf(oneOfType([number, string])),
  onClick: func,
  isDisabled: bool.isRequired,
};

ProductCardTitleLabel.defaultProps = {
  ids: [],
  onClick: () => {},
};

export default ProductCardTitleLabel;
